import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import s from './TotalSavingsRow.scss';

export enum TotalSavingsRowDataHook {
  Root = 'TotalSavingsRow.Root',
  Icon = 'TotalSavingsRow.Icon',
  Text = 'TotalSavingsRow.Text',
}

export const TotalSavingsRow = () => {
  const {t} = useTranslation();
  const {cartSummary} = useControllerProps().cartStore;

  if (!cartSummary?.totalSavings.convertedAmount) {
    return null;
  }

  return (
    <div data-hook={TotalSavingsRowDataHook.Root} className={s.root}>
      <TagSmall aria-hidden data-hook={TotalSavingsRowDataHook.Icon} />
      <span data-hook={TotalSavingsRowDataHook.Text}>
        {t('cart.order_summary.total_savings', {totalAmountSaved: cartSummary.totalSavings.formattedConvertedAmount})}
      </span>
    </div>
  );
};
